import styled from 'styled-components';

export const SeverityColorCell = styled.div`
    border-radius: 6px;
    color: #fff;
    width: 100%;
    height: 100%;
    padding: 8px;
`;